import * as React from "react";
import { invoiceDetailUrl } from "../../../store/billectaInvoicing";

// style, design
import { DateCell, LinkedObject, TimeCell, ToolTipCell } from "../../Displays";
import { TextButton } from "../../Forms/Base/Buttons";

import { invoicingToContractDetailUrl as leaseDetailUrl } from "../../../store/invoicingLease";
import { invoicingToContractDetailUrl as otherDetailUrl } from "../../../store/invoicingOther";
import { invoicingToContractDetailUrl as parkingDetailUrl } from "../../../store/invoicingParking";
import { invoicingToContractDetailUrl as brfDetailUrl } from "../../../store/invoicingBrf";

import SimpleTextFilter from "src/components/Lists/Base/CompleteList/Filters/TextFilter";

export const getReadableInvoiceRecordDescription = (record) => {
  if (!record) return "";
  if (record.billecta_id) {
    if (!record.merged) {
      return "Avi genererades";
    } else {
      return "Avi genererades och sammanfördes";
    }
  } else {
    if (record.skipped_generating) {
      return "Avi hoppades över då beloppet var 0 SEK";
    } else {
      return "Avi misslyckades att genereras";
    }
  }
};

export const getReadableInvoiceCreator = (record) => {
  if (record?.from_auto) {
    return "System";
  } else {
    return record?.owner?.str_representation || "Användare";
  }
};

export default (push) => [
  {
    Header: "Uppdaterades",
    accessor: "updated_at",
    Cell: ({ value, row }) => {
      return <TimeCell date={value} />;
    },
    Filter: SimpleTextFilter,
    filter: "text",
  },
  {
    Header: "Källa",
    id: "source",
    Cell: ({ row }) => {
      let obj;
      let urlMethod;

      if (row.original.lease_invoicing) {
        obj = row.original.lease_invoicing;
        urlMethod = leaseDetailUrl;
      }
      if (row.original.other_invoicing) {
        obj = row.original.other_invoicing;
        urlMethod = otherDetailUrl;
      }
      if (row.original.parking_invoicing) {
        obj = row.original.parking_invoicing;
        urlMethod = parkingDetailUrl;
      }
      if (row.original.brf_invoicing) {
        obj = row.original.brf_invoicing;
        urlMethod = brfDetailUrl;
      }

      if (!obj || !urlMethod) return "Källa saknas";

      return <LinkedObject {...{ obj, urlMethod }} />;
    },
    Filter: SimpleTextFilter,
    filter: "text",
  },
  {
    Header: "Händelse",
    id: "event",
    Cell: ({ row }) => (
      <ToolTipCell text={getReadableInvoiceRecordDescription(row.original)} />
    ),
    Filter: SimpleTextFilter,
    filter: "text",
  },
  {
    Header: "Genererad av",
    id: "from_auto",
    Cell: ({ row }) => (
      <ToolTipCell text={getReadableInvoiceCreator(row.original)} />
    ),
    Filter: SimpleTextFilter,
    filter: "text",
  },
  {
    Header: "Period start",
    accessor: "period_start",
    Cell: ({ value, row }) => {
      return <DateCell date={value} />;
    },
    Filter: SimpleTextFilter,
    filter: "text",
  },
  {
    Header: "Period slut",
    accessor: "period_end",
    Cell: ({ value }) => <DateCell date={value} />,
    Filter: SimpleTextFilter,
    filter: "text",
  },
  {
    Header: "Avidatum",
    accessor: "invoice_date",
    Cell: ({ value }) => <DateCell date={value} />,
    Filter: SimpleTextFilter,
    filter: "text",
  },
  {
    Header: "Förfallodatum",
    accessor: "due_date",
    Cell: ({ value }) => <DateCell date={value} />,
    Filter: SimpleTextFilter,
    filter: "text",
  },
  {
    Header: "Kopplad avi",
    id: "invoice",
    Cell: ({ row }) => {
      if (!row.original.billecta_id)
        return <ToolTipCell text={"Ingen kopplad avi"} />;

      return (
        <TextButton
          title="Gå till avi"
          iconType="arrow"
          iconPlacement="right"
          clicked={() =>
            push(
              invoiceDetailUrl({
                creditorId: row.original.billecta_id?.creditor_id,
                invoiceId: row.original.billecta_id?.object_id,
              })
            )
          }
        />
      );
    },
    Filter: SimpleTextFilter,
    filter: "text",
  },
];
